module.exports = __webpack_public_path__ + "stockLibrary/cross-sell-modal-top-image-edbc7eaab8aa857b620991a840070db6.png";